import { useEffect } from "react";

// Basic interval hook
export default function useInterval(
  fn: () => void,
  duration: number,
  disable = false
) {
  useEffect(() => {
    let id: number;
    if (!disable) {
      id = window.setInterval(fn, duration);
    }
    return () => window.clearInterval(id);
  }, [fn, duration, disable]);
}
